<template>
  <img src="@/assets/svg/enlarge-grey.svg" alt="enlarge" />
</template>
